module.exports = __webpack_public_path__ + "img/close.540a3dde.svg";